/** PC 左メニュー: スクロール位置に応じて該当ナビに is-active（セクション ID はベタ書き） */
const SECTION_IDS = [
  "photo",
  "coordinate",
  "gourmet",
  "entertainment",
  "real",
  "guide",
  "faq",
];

const NAV_LINKS = ".pc-menu__nav .pc-menu__nav-link";
const BREAKPOINT = "(min-width: 1025px)";

const getElDocTop = (el) => {
  const rect = el.getBoundingClientRect();
  return rect.top + window.scrollY;
};

const parseOffset = (value) => {
  if (!value) return 0;
  const num = parseFloat(value);
  if (value.endsWith("rem")) {
    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    return num * rootFontSize;
  }
  return num;
};

export const pcMenuNavActive = () => {
  const links = document.querySelectorAll(NAV_LINKS);
  if (!links.length) return;

  let ticking = false;

  const update = () => {
    const header = document.querySelector(".js-header");
    const headerH = header ? header.offsetHeight : 0;
    const line = window.scrollY + headerH;

    let activeId = "";
    for (const id of SECTION_IDS) {
      const el = document.getElementById(id);
      if (!el) continue;
      const offset = parseOffset(el.dataset.anchorOffset);
      if (getElDocTop(el) - (offset + 1) <= line) {
        activeId = id;
      }
    }

    links.forEach((link) => {
      const href = link.getAttribute("href");
      if (href === `#${activeId}` && activeId) {
        link.classList.add("is-active");
      } else {
        link.classList.remove("is-active");
      }
    });
  };

  const onScrollOrResize = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      update();
      ticking = false;
    });
  };

  const mq = window.matchMedia(BREAKPOINT);

  const handleChange = (e) => {
    if (e.matches) {
      window.addEventListener("scroll", onScrollOrResize, { passive: true });
      window.addEventListener("resize", onScrollOrResize);
      update();
    } else {
      window.removeEventListener("scroll", onScrollOrResize);
      window.removeEventListener("resize", onScrollOrResize);
      links.forEach((link) => link.classList.remove("is-active"));
    }
  };

  mq.addEventListener("change", handleChange);
  handleChange(mq);
};
